import React from 'react';
import P3ConfigurationExportContainer from 'containers/P3ConfigurationExportContainer';
import ExportConfiguration from 'views/components/P3ConfigurationExport/ExportConfiguration';
import ExportPage from 'views/components/P3ConfigurationExport/ExportPage';
import ExportTable from 'views/components/P3ConfigurationExport/ExportTable';
import ExplotPlotPie from 'views/components/P3ConfigurationExport/ExportPlotPie';
import ExportPlotHeader from 'views/components/P3ConfigurationExport/ExportPlotHeader';
import { p3PoitnsAlgorithm } from '@tpco/tpco-saturn-logic';
import {
  ConfigurationPoint,
  ConfigurationBarPoint
} from 'models/interfaces/configurationExport/export';
// import '../../components/P3ConfigurationExport/blueprint/blueprint-fix.scss';
interface P3ConfigurationPageProps {
  match: any;
}

class P3ConfigurationExportPage extends React.Component<P3ConfigurationPageProps> {
  constructor(props: P3ConfigurationPageProps) {
    super(props);

    this.state = {
      isModalOpen: false
    };
  }
  render() {
    const { tgramsId, campaignId, configurationId } = this.props.match.params;
    console.log(tgramsId);
    console.log(configurationId);
    console.log(campaignId);

    return (
      <P3ConfigurationExportContainer
        tgrams_id={tgramsId || ''}
        campaign_id={campaignId || ''}
        configuration_id={configurationId || ''}
      >
        {({
          nationalPointsData,
          nationalTableData,
          regionalPointsData,
          regionalTableData,
          pointsData,
          account,
          campaign,
          user,
          configuration
        }) => (
          <ExportConfiguration
            headerLabel={
              account && account.name
                ? account.name.replace('&amp;', '&')
                : configuration && configuration.name
                ? configuration.name.replace('&amp;', '&')
                : 'Configuration Export'
            }
            email={user ? user.email : ''}
          >
            {/* Footer will be dynamically generated thru Puppeteer */}
            <ExportPage
              footer={false}
              overflow={true}
              label={
                account && account.name
                  ? account.name.replace('&amp;', '&')
                  : configuration && configuration.name
                  ? configuration.name.replace('&amp;', '&')
                  : 'Configuration Export'
              }
              email={user ? user.email : ''}
              header={true}
            >
              {/* National Points */}
              <section>
                <ExportPlotHeader
                  points={p3PoitnsAlgorithm(
                    configuration.rank_points,
                    configuration.coverage_areas
                  )}
                  pointsData={pointsData ? pointsData : ([] as ConfigurationBarPoint[])}
                />
                {nationalPointsData && nationalPointsData.length > 0 ? (
                  <ExplotPlotPie
                    className="points-allocation-chart--national"
                    data={nationalPointsData}
                    title="National Points Allocation"
                  />
                ) : null}
                {nationalTableData && nationalTableData.length > 0 ? (
                  <ExportTable
                    data={nationalTableData ? nationalTableData : ([] as ConfigurationPoint[])}
                    title="All Categories With National Points Allocated"
                  />
                ) : null}
              </section>

              {/* Regional Points */}
              {regionalPointsData && regionalPointsData.length > 0 && (
                <section
                  className={
                    nationalPointsData && nationalPointsData.length > 0
                      ? ' pagebreak--before'
                      : 'nobreak'
                  }
                >
                  <ExplotPlotPie
                    className="points-allocation-chart--regional"
                    data={regionalPointsData}
                    title="Regional Points Allocation"
                  />
                  <ExportTable
                    data={regionalTableData ? regionalTableData : ([] as ConfigurationPoint[])}
                    title="All Categories With Regional Points Allocated"
                  />
                </section>
              )}
            </ExportPage>
          </ExportConfiguration>
        )}
      </P3ConfigurationExportContainer>
    );
  }
}

export default P3ConfigurationExportPage;
